import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Spinner from '../../components/generics/Spinner';
import _ from 'lodash';
import queryString from 'query-string';

import ReactPaginate from 'react-paginate';

import ReportShipment from '../../components/reports/ReportShipment';
import Filter from '../../components/generics/Filter';
import ReportHeader from '../../components/generics/ReportHeader';

import { fetchShipmentReport, fetchShipmentReportSuccess, fetchShipmentReportFailure } from "../../store/reports/actions";
import { fetchDestinations, fetchDestinationsSuccess, fetchDestinationsFailure } from "../../store/shipments/actions";

import { fetchShipmentReportCSV } from '../../store/reports/api';

import { STARTING_PAGE, DEBOUNCE_SEARCH } from '../../constants/constants';
import { withRouter } from "utils/WithRouter";

export class ReportShipmentContainer extends Component {

  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props){
    super(props);
    this.state = {
      page: 1,
      filterFrom: moment().subtract(1, 'week').format('YYYY-MM-DD'),
      filterTo: moment().format('YYYY-MM-DD'),
      selectedPlant: '',
      selectedLot: '',
      selectedShipmentID: '',
      selectedCustomer: '',
      searchInventory: ''
    };

    this.changeSearch = _.debounce(() => {
      this.searchRefresh()
      this.updateQueryString();
    }, DEBOUNCE_SEARCH);
  }

  componentDidMount() {

    const params = queryString.parse(this.props.location.search);
    const filterFrom = params.from ? params.from : this.state.filterFrom;
    const filterTo = params.to ? params.to : this.state.filterTo;
    const selectedCustomer = params.customer ? params.customer : this.state.selectedCustomer;
    const searchInventory = params.inventory ? params.inventory : undefined;
    const selectedPlant = params.plant ? params.plant : this.state.selectedPlant;
    const selectedLot = params.lot ? params.lot : this.state.selectedLot;
    const selectedShipmentID = params.shipment_id ? params.shipment_id : this.state.selectedShipmentID;
    const page = params.page ? params.page : STARTING_PAGE;

    // Fetch initial page
    this.setState({page, filterFrom, filterTo, searchInventory, selectedCustomer, selectedPlant, selectedLot, selectedShipmentID}, () => {
      this.props.getFilteredShipments(page, filterFrom, filterTo, searchInventory, selectedCustomer, selectedPlant, selectedLot, selectedShipmentID);
    });

    // Fetch destinations for customer filter
    if (!this.props.destinationsList.destinations || this.props.destinationsList.destinations.length === 0) {
      this.props.fetchDestinations();
    }

  }

  // ---------------------------------------------------------------------------
  // Filters handling
  // ---------------------------------------------------------------------------

  onFromDateChange = (event) => {
    let filterFrom = event.target.value ? event.target.value : this.state.filterFrom;
    this.setState({ filterFrom, page: STARTING_PAGE }, () => {
        this.changeSearch();
    });
  };

  onToDateChange = (event) => {
    let filterTo = event.target.value ? event.target.value : this.state.filterTo;
    this.setState({ filterTo, page: STARTING_PAGE }, () => {
        this.changeSearch();
    });
  };

  onSearchChange = (event) => {
    let searchInventory = event.target.value ? event.target.value : '';
    this.setState({ searchInventory, page: STARTING_PAGE }, () => {
        this.changeSearch();
    });
  };

  onPlantChange = (event) => {
    const selectedPlant = event.target.value ? event.target.value : "";
    this.setState({ selectedPlant }, () => {
      this.changeSearch();
    });
  };

  onShipmentIDChange = (event) => {
    const selectedShipmentID = event.target.value ? event.target.value : "";
    this.setState({ selectedShipmentID }, () => {
      this.changeSearch();
    });
  };

  onLotChange = (event) => {
    const selectedLot = event.target.value ? event.target.value : "";
    this.setState({ selectedLot }, () => {
      this.changeSearch();
    });
  };

  onCustomerChange = (event) => {
    let selectedCustomer = event.target.value && parseInt(event.target.value, 10) !== -1 ? event.target.value : '';
    this.setState({ selectedCustomer, page: STARTING_PAGE }, () => {
        this.changeSearch();
    });
  };

  searchRefresh = () => {
    const { page, filterFrom, filterTo, searchInventory, selectedCustomer, selectedPlant, selectedLot, selectedShipmentID} = this.state
    this.props.getFilteredShipments(page, filterFrom, filterTo, searchInventory, selectedCustomer, selectedPlant, selectedLot, selectedShipmentID);
  };

  updateQueryString = () => {
    const {page, filterFrom, filterTo, searchInventory, selectedCustomer, selectedPlant, selectedLot, selectedShipmentID} = this.state
    let params = {};
    if (filterFrom) params.from = filterFrom
    if (filterTo) params.to = filterTo
    if (searchInventory) params.inventory = searchInventory
    if (selectedCustomer) params.customer = selectedCustomer
    if (selectedPlant) params.plant = selectedPlant;
    if (selectedLot) params.lot = selectedLot;
    if (selectedShipmentID) params.shipment_id = selectedShipmentID;
    params.page = page;
    this.props.history.push({
      search: queryString.stringify(params)
    })
  };

  // ---------------------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------------------
  handlePageRequest = (data) => {
    let page = data.selected + 1;
    if(page !== this.state.page){
      this.setState({ page }, () => {
          this.updateQueryString();
          this.searchRefresh();
      });
    };
  };

  // ---------------------------------------------------------------------------
  // CSV
  // ---------------------------------------------------------------------------

  loadCsv = () => {
    const {filterFrom, filterTo, searchInventory, selectedCustomer, selectedPlant, selectedLot, selectedShipmentID} = this.state
    let fileName = `${moment(filterFrom).format('MMM DD')}-${moment(filterTo).format('MMM DD')}.csv`
    this.setState({
        csvIsloading: true,
    })
    fetchShipmentReportCSV(
      filterFrom, filterTo, searchInventory, selectedCustomer, selectedPlant, selectedLot, selectedShipmentID
    ).then((r) => {
      let blob = new Blob([r.data], { type: 'text/csv' })
      let link = document.createElement('a')
      document.body.appendChild(link);
      link.href = window.URL.createObjectURL(blob)
      link.setAttribute('download', fileName);
      link.click();
      document.body.removeChild(link);
      this.setState({
        csvIsloading: false,
      })
    }).catch((err) => {
      console.log(err);
      this.setState({
        csvIsloading: false,
      })
    });
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render(){
    if (!this.state.filterFrom || !this.state.filterTo){
      return <Spinner />;
    } else {
      return (
        <div>
          <div className="card mb-2">
            <ReportHeader title='Shipment Report'
                          actionTitle='Export CSV'
                          actionClass='btn btn-primary m-0'
                          csvLoading={this.state.csvIsloading}
                          fromFile={true}
                          loadCsv={this.loadCsv}
            />
            <Filter
              searchLabel="Search Inventory"
              searchPlaceholder="Search by Name"
              searchVal={this.state.searchInventory}
              onSearchChange={this.onSearchChange}
              dateLabel="From Date"
              dateVal={this.state.filterFrom}
              onDateChange={this.onFromDateChange}
              dateLabel2="To Date"
              dateVal2={this.state.filterTo}
              onDateChange2={this.onToDateChange}
              dropdownLabel="Customer"
              dropdownPlaceholder="All customers"
              dropdownVal={this.state.selectedCustomer}
              onDropdownChange={this.onCustomerChange}
              dropdownByElementId
              dropdownOptions={this.props.destinationsList.destinations}
              searchLabel2="Search shipment ID"
              searchPlaceholder2="Search by shipment ID"
              searchVal2={this.state.selectedShipmentID}
              onSearchChange2={this.onShipmentIDChange}
              searchLabel3="Plant"
              searchPlaceholder3="Search by plant"
              searchVal3={this.state.selectedPlant}
              onSearchChange3={this.onPlantChange}
              searchLabel4="Lot"
              searchPlaceholder4="Search by lot"
              searchVal4={this.state.selectedLot}
              onSearchChange4={this.onLotChange}
              colClass="col-12 col-sm-3"
            />
          </div>
          <ReportShipment shipmentsList={this.props.shipmentReport.shipments}/>
          {this.props.shipmentReport.pages > 1 &&
            <ReactPaginate pageCount={this.props.shipmentReport.pages}
                            pageRangeDisplayed={2}
                            marginPagesDisplayed={1}
                            previousLabel="<"
                            nextLabel=">"
                            onPageChange={this.handlePageRequest}
                            initialPage={this.state.page-1}
                            disableInitialCallback={true}
                            containerClassName="pagination"
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            activeClassName="page-item active"
                            previousClassName="paginate_button previous"
                            nextClassName="paginate_button next"
                            disabledClassName="page-item disabled"
                            forcePage={this.state.page-1}/>
          }
          {this.props.shipmentReport.loading ? <Spinner /> : null}
        </div>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    shipmentReport: state.reports.shipmentReport,
    currentUser: state.auth.currentUser,
    destinationsList: state.shipments.destinationsList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFilteredShipments: (page, from, to, searchId='', selectedCustomer, selectedPlant, selectedLot, selectedShipmentID) => {
      dispatch(fetchShipmentReport(page, from, to, searchId, selectedCustomer, selectedPlant, selectedLot, selectedShipmentID)).payload.then((response) => {
        dispatch(fetchShipmentReportSuccess(response.data));
      }, (error) => {
        dispatch(fetchShipmentReportFailure(error));
      });
    },
    fetchDestinations: () => {
      dispatch(fetchDestinations()).payload.then((response) => {
        dispatch(fetchDestinationsSuccess(response.data))
      }, (error) => {
        dispatch(fetchDestinationsFailure(error));
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReportShipmentContainer));
